import { createSlice } from "@reduxjs/toolkit";

const emptyObj: { open: boolean; data: any } = { open: false, data: null };

export const modalSlice = createSlice({
  name: "modal",
  initialState: {
    playerRankingModal: emptyObj,
    playerProfileModal: emptyObj,
    settingsModal: emptyObj,
    accountModal: emptyObj,
    chatbotSearchModal: emptyObj,
    leagueModal: emptyObj,
    newsDetilsModal: emptyObj,
    chatBotHistoryModal: emptyObj,
    advancedStatsModal: emptyObj,
    AppUpdateModal: emptyObj,
    sleeperModal: emptyObj,
    leagueSelectionModal: emptyObj,
    AddNewLeague: emptyObj,
    bookCallModal: emptyObj,
    tradeAnalyzerModal: emptyObj,
    playerSearchModal: emptyObj,
    leagueSettingsModal: emptyObj,
    leagueTypeModal: emptyObj,
    scoringFormatModal: emptyObj,
    advancedStatsPromoPopup : emptyObj
  },
  reducers: {
    //PlayerRanking
    openPlayerRankingModal: (state: any, { payload }: any) => {
      state.playerRankingModal = { open: true, data: payload };
    },
    closePlayerRankingModal: (state) => {
      state.playerRankingModal = emptyObj;
    },

    //PlayerProfile
    openPlayerProfileModal: (state: any, { payload }: any) => {
      state.playerProfileModal = { open: true, data: payload };
    },
    closePlayerProfileModal: (state) => {
      state.playerProfileModal = emptyObj;
    },

    //SettingsModal
    openSettingsModal: (state: any, { payload }: any) => {
      state.settingsModal = { open: true, data: payload };
    },
    closeSettingsModal: (state) => {
      state.settingsModal = emptyObj;
    },

    //AccountModal
    openAccountModal: (state: any, { payload }: any) => {
      state.accountModal = { open: true, data: payload };
    },
    closeAccountModal: (state) => {
      state.accountModal = emptyObj;
    },

    //ChatbotSearchModal
    openChatbotSearchModal: (state: any, { payload }: any) => {
      state.chatbotSearchModal = { open: true, data: payload };
    },
    closeChatbotSearchModal: (state) => {
      state.chatbotSearchModal = emptyObj;
    },

    //LeagueModal
    openLeagueModal: (state: any, { payload }: any) => {
      state.leagueModal = { open: true, data: payload };
    },
    closeLeagueModal: (state) => {
      state.leagueModal = emptyObj;
    },

    //NewsDetailsModal
    openNewsDetailsModal: (state: any, { payload }: any) => {
      state.newsDetilsModal = { open: true, data: payload };
    },
    closeNewsDetailsModal: (state) => {
      state.newsDetilsModal = emptyObj;
    },

    //ChatBotHistoryModal
    openChatBotHistoryModal: (state: any, { payload }: any) => {
      state.chatBotHistoryModal = { open: true, data: payload };
    },
    closeChatBotHistoryModal: (state) => {
      state.chatBotHistoryModal = emptyObj;
    },

    //AdvancedStatsModal
    openAdvancedStatsModal: (state: any, { payload }: any) => {
      state.advancedStatsModal = { open: true, data: payload };
    },
    closeAdvancedStatsModal: (state) => {
      state.advancedStatsModal = emptyObj;
    },

    //AppUpdateModal
    openAppUpdateModal: (state: any, { payload }: any) => {
      state.AppUpdateModal = { open: true, data: payload };
    },
    closeAppUpdateModal: (state) => {
      state.AppUpdateModal = emptyObj;

    },
    //SleeperModal
    openSleeperModal: (state: any, { payload }: any) => {
      state.sleeperModal = { open: true, data: payload };
    },
    closeSleeperModal: (state) => {
      state.sleeperModal = emptyObj;
    },

    //LeagueSelectionModal
    openLeagueSelectionModal: (state: any, { payload }: any) => {
      state.leagueSelectionModal = { open: true, data: payload };
    },
    closeLeagueSelectionModal: (state) => {
      state.leagueSelectionModal = emptyObj;
    },

    //AddNewLeague
    openAddNewLeagueModal: (state: any, { payload }: any) => {
      state.AddNewLeague = { open: true, data: payload };
    },
    closeAddNewLeagueModal: (state) => {
      state.AddNewLeague = emptyObj;
    },

    //BookCallModal
    openBookCallModal: (state: any, { payload }: any) => {
      state.bookCallModal = { open: true, data: payload };
    } ,
    closeBookCallModal: (state) => {
      state.bookCallModal = emptyObj;
    },
    //TradeAnalyzerModal
    openTradeAnalyzerModal: (state: any, { payload }: any) => {
      state.tradeAnalyzerModal = { open: true, data: payload };
    },
    closeTradeAnalyzerModal: (state) => {
      state.tradeAnalyzerModal = emptyObj;
    },

    //PlayerSearchModal
    openPlayerSearchModal: (state: any, { payload }: any) => {
      state.playerSearchModal = { open: true, data: payload };
    },
    closePlayerSearchModal: (state) => {
      state.playerSearchModal = emptyObj;
    },

    //LeagueSettingsModal 
    openLeagueSettingsModal: (state: any, { payload }: any) => {
      state.leagueSettingsModal = { open: true, data: payload };
    },
    closeLeagueSettingsModal: (state) => {
      state.leagueSettingsModal = emptyObj;
    },

    //LeagueTypeModal
    openLeagueTypeModal: (state: any, { payload }: any) => {
      state.leagueTypeModal = { open: true, data: payload };
    },
    closeLeagueTypeModal: (state) => {
      state.leagueTypeModal = emptyObj; 
    },

    //ScoringFormatModal
    openScoringFormatModal: (state: any, { payload }: any) => {
      state.scoringFormatModal = { open: true, data: payload };
    },
    closeScoringFormatModal: (state) => { 
      state.scoringFormatModal = emptyObj;
    },

    //AdvancedStatsPromoPopup
    openAdvancedStatsPromoPopup: (state: any, { payload }: any) => {
      state.advancedStatsPromoPopup = { open: true, data: payload };
    },
    closeAdvancedStatsPromoPopup: (state) => {
      state.advancedStatsPromoPopup = emptyObj;
    },

    //CloseAllModals
    closeAllModals: (state) => {
      state.playerRankingModal = emptyObj;
      state.playerProfileModal = emptyObj;
      state.settingsModal = emptyObj;
      state.accountModal = emptyObj;
      state.chatbotSearchModal = emptyObj;
      state.leagueModal = emptyObj;
      state.newsDetilsModal = emptyObj;
      state.chatBotHistoryModal = emptyObj;
      state.advancedStatsModal = emptyObj;
      state.AppUpdateModal = emptyObj;
      state.sleeperModal = emptyObj;
      state.leagueSelectionModal = emptyObj;
      state.AddNewLeague = emptyObj;
      state.bookCallModal = emptyObj;
      state.tradeAnalyzerModal = emptyObj;
      state.playerSearchModal = emptyObj;
      state.leagueSettingsModal = emptyObj;
      state.leagueTypeModal = emptyObj;
      state.scoringFormatModal = emptyObj;
      state.advancedStatsPromoPopup = emptyObj;
    }
  },
});
export const {
  //open
  openPlayerRankingModal,
  openPlayerProfileModal,
  openSettingsModal,
  openAccountModal,
  openChatbotSearchModal,
  openLeagueModal,
  openNewsDetailsModal,
  openChatBotHistoryModal,
  openAdvancedStatsModal,
  openAppUpdateModal,
  openSleeperModal,
  openLeagueSelectionModal,
  openAddNewLeagueModal,
  openBookCallModal,
  openTradeAnalyzerModal,
  openPlayerSearchModal,
  openLeagueSettingsModal,
  openLeagueTypeModal,
  openScoringFormatModal,
  openAdvancedStatsPromoPopup,

  //close
  closePlayerRankingModal,
  closePlayerProfileModal,
  closeSettingsModal,
  closeAccountModal,
  closeChatbotSearchModal,
  closeLeagueModal,
  closeNewsDetailsModal,
  closeChatBotHistoryModal,
  closeAdvancedStatsModal,
  closeSleeperModal,
  closeLeagueSelectionModal,
  closeAddNewLeagueModal,
  closeAppUpdateModal,
  closeTradeAnalyzerModal,
  closePlayerSearchModal,
  closeLeagueSettingsModal,
  closeLeagueTypeModal,
  closeScoringFormatModal,
  closeAdvancedStatsPromoPopup,
  closeAllModals
} = modalSlice.actions;
export default modalSlice.reducer;
